import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import breakpointValues from "@starter/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@starter/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const siteWidthStyles = (sideSpacing?: string[]) => {
    return css`
        max-width: ${x => pxToRem(x.theme.design.layout.siteWidth)};
        margin-right: auto;
        margin-left: auto;
        ${x => breakpointValues(sideSpacing || x.theme.design.layout.spacing.side, ["padding-right", "padding-left"])}

        @media print {
            max-width: none;
            padding-right: 0;
            padding-left: 0;
        }
    `;
};

export const contentWidthStyles = () => {
    return css`
        max-width: ${x => pxToRem(x.theme.design.layout.contentWidth)};
        margin-right: auto;
        margin-left: auto;
    `;
};

export const clearfixStyles = () => {
    return css`
        &::before,
        &::after {
            content: "";
            display: table;
        }

        &::after {
            clear: both;
        }
    `;
};

export const visuallyHiddenStyles = () => {
    return css`
        position: absolute;
        width: ${pxToRem(1)};
        height: ${pxToRem(1)};
        margin: ${pxToRem(-1)};
        border: 0;
        padding: 0;
        white-space: nowrap;
        clip-path: inset(100%);
        clip: rect(0 0 0 0);
        overflow: hidden;
    `;
};

export const focusOutlineStyles = (offset?: string | true, width?: string, style?: string, color?: string) => {
    return css`
        ${({ theme }) => {
            const _offset = offset === true ? `-${theme.focus.width}` : offset;

            return `
                outline-offset: ${_offset || theme.focus.offset};
                outline-width: ${width || theme.focus.width};
                outline-style: ${style || theme.focus.style};
                outline-color: ${color || theme.focus.color};
            `;
        }}
    `;
};

export const focusUpdateStyles = (offset?: string | true, width?: string, style?: string, color?: string) => {
    if (!offset && !width && !style && !color) {
        return null;
    }

    return css`
        &:focus,
        &:focus-visible {
            ${({ theme }) => {
                const _offset = offset === true ? `-${theme.focus.width}` : offset;

                return `
                    ${_offset ? `outline-offset: ${_offset};` : ""}
                    ${width ? `outline-width: ${width};` : ""}
                    ${style ? `outline-style: ${style};` : ""}
                    ${color ? `outline-color: ${color};` : ""}
                `;
            }}
        }
    `;
};

export const focusStyles = (offset?: string | true, width?: string, style?: string, color?: string) => {
    return css`
        &:focus,
        &:focus-visible {
            ${focusOutlineStyles(offset, width, style, color)}
        }

        &:not(:focus-visible) {
            outline: none;
        }
    `;
};

export const stretchStyles = (isZoneWrapper?: boolean) => {
    return css`
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        ${() => (isZoneWrapper ? _stretchZoneWrapperCss : null)}

        @media print {
            display: block; /* Required for PDF Generation */
        }
    `;
};

// prettier-ignore
const _stretchZoneWrapperCss: StyledProp = css`
    > [class^="Wrapper"],
    > [class^="Wrapper"] > [data-widget]:first-child,
    > [class^="ZoneStyle"],
    > [class^="ZoneStyle"] > [class^="ZoneWrapper"],
    > [class^="ZoneStyle"] > [class^="ZoneWrapper"] > [data-widget]:first-child,
    > [class^="ZoneStyle"] > [class^="ZoneWrapper"] > [data-widget]:first-child > [class^="WidgetStyle"],
    > [class^="ZoneStyle"] > [class^="ZoneWrapper"] > [data-widget]:first-child > [class^="WidgetStyle"] > [class^="WidgetWrapper"] {
        ${stretchStyles()}
    }

    > [class^="ZoneStyle"] > [class^="ZoneWrapper"] {
        justify-content: center;

        > [class^="AddContainer"]:not(:first-child) {
            display: none;
        }
    }
`;
